import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import { MfaPreference } from 'gql/graphql';
import { updateMFAPreferenceMutation } from './updateMFAPreferenceMutation';

export interface ILogin {
  email: string;
  password: string;
}

@Injectable({
  providedIn: 'root',
})
export class CognitoMfaPreferenceService {
  apollo = inject(Apollo);

  // private get appsyncEndpoint(): string {
  //   return environment.cognito.userPoolId.includes('eu-central-1')
  //     ? 'https://75s7lctypfbvhg47mdrvuf7euu.appsync-api.eu-central-1.amazonaws.com/graphql'
  //     : (this.apollo.client as any).link?.options?.uri || '';
  // }

  /**
   * Creates Apollo client with Basic Auth for Lambda Authorizer
   */
  // private createMFAClient(email: string, password: string): ApolloClient<any> {
  //   const credentials = btoa(`${email}:${password}`);

  //   return new ApolloClient({
  //     link: new HttpLink({
  //       uri: this.appsyncEndpoint,
  //       headers: {
  //         'Authorization': `Basic ${credentials}`,
  //         'Content-Type': 'application/json'
  //       }
  //     }),
  //     cache: new InMemoryCache(),
  //     defaultOptions: {
  //       watchQuery: { fetchPolicy: 'no-cache' },
  //       query: { fetchPolicy: 'no-cache' },
  //     }
  //   });
  // }

  public async toggleMFAPreference(
    user: ILogin,
    preferredChallenge: 'email' | 'totp'
  ): Promise<void> {
    await firstValueFrom(
      preferredChallenge === 'email'
        ? this.apollo.mutate({
            mutation: updateMFAPreferenceMutation,
            variables: {
              email: user.email,
              password: user.password,
              preferences: {
                email: MfaPreference.Preferred,
                sms: MfaPreference.Disabled,
              },
            },
            context: {
              basic: btoa(`${user.email}:${user.password}`),
            },
          })
        : this.apollo.mutate({
            mutation: updateMFAPreferenceMutation,
            variables: {
              email: user.email,
              password: user.password,
              preferences: {
                totp: MfaPreference.Preferred,
                sms: MfaPreference.Disabled,
              },
            },
            context: {
              basic: btoa(`${user.email}:${user.password}`),
            },
          })
    );
  }

  public async disableTOTP(user: ILogin): Promise<void> {
    await firstValueFrom(
      this.apollo.mutate({
        mutation: updateMFAPreferenceMutation,
        variables: {
          email: user.email,
          password: user.password,
          preferences: {
            totp: MfaPreference.Disabled,
            sms: MfaPreference.Disabled,
          },
        },
        context: {
          basic: btoa(`${user.email}:${user.password}`),
        },
      })
    );
  }
}
